import styled from "styled-components";

export const Div = styled.div`
	.contact-contents {
		display: block;
		margin-top: 5px;
		position: relative;
		font-weight: 500;
		width: 100%;
	}
	.firm-idv-contact {
		display: flex;
		padding: 5px 0;
		img {
			height: 100%;
			width: 100%;
			min-width: 20px;
			max-width: 50px;
			max-height: 50px;
			min-height: 20px;
		}
	}
	.contact-img {
		img {
			border-radius: 50%;
		}
		.ava {
			width: 44px;
			height: 44px;
			border-radius: 50%;
			background: #f0f8ff;
		}
	}
	.contact-name {
		display: flex;
		margin: auto 0;
		padding-left: 15px;
		font-size: 0.875rem;
		font-weight: 500;
		color: rgb(44, 118, 170);
		text-decoration: underline;
	}
	.contact-name-service {
		display: flex;
		margin: auto 0;
		padding-left: 15px;
		font-size: 0.875rem;
		font-weight: 500;
		color: rgb(88 88 91);
	}
	.mgs-btn {
		height: fit-content;
		margin-top: 10px;
		width: 100%;
		padding: 10px 0px;
	}
	.srv-web-btn {
		height: fit-content;
		width: 100%;
		padding: 10px 7px;
		display: flex;
	}
	.srv-web-btn p {
		font-size: 0.875rem;
		font-weight: 400;
		line-height: 22px;
		padding-left: 10px;
		margin: auto 0;
		margin-bottom: -5px;
		text-decoration: underline;
	}
	.srv-web-btn svg {
		margin: auto 0;
	}
	.btn {
	}
`;
